function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _excluded = ["columnBackgrounds", "columnWidths", "columnHeights", "columnPaddings", "columnBorderStyles", "columnBorderWidths", "columnBorderColors", "columnBorderRadii", "columnAlignItems", "columnJustifyContents", "imageShape", "transform"],
  _excluded2 = ["gap"];
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { UI, BuilderIcon, DEFAULT_FONT } from "../../../builderUiTheme";
import { BLOCK_TEXT_WRAP_STYLE } from "../../constants/defaultBlocks";
import { resolveNodeFontFamily, resolveFontWeight, resolveBorderStyleProps, resolveStyleMaxWidth, pickMarginStyle, omitMarginFromStyle, resolveStyleWithBackgroundOverlay, omitInheritedColumnTextColor, isColumnLayoutType, getColumnLayoutGapConfig, getColumnLayoutOuterWidth, getCircularColumnBoxSize, isNestedColumnContent, isIntrinsicColumnWidth } from "../../utils/helpers";
import CanvasBlockRenderer from "./CanvasBlockRenderer";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var DROP_HYSTERESIS_PX = 12;
var EDGE_DROP_PX = 36;
var DROP_LINE_COLOR = "#38bdf8";
var DROP_LINE_OUTLINE = "#ffffff";
function DropIndicator(_ref) {
  var top = _ref.top;
  return /*#__PURE__*/_jsxs("div", {
    "aria-hidden": "true",
    style: {
      position: "absolute",
      top: Math.max(0, top - 5),
      left: 0,
      right: 0,
      height: 10,
      display: "flex",
      alignItems: "center",
      pointerEvents: "none",
      zIndex: 100
    },
    children: [/*#__PURE__*/_jsx("span", {
      style: {
        width: 10,
        height: 10,
        borderRadius: "50%",
        background: DROP_LINE_OUTLINE,
        border: "2px solid ".concat(DROP_LINE_COLOR),
        boxShadow: "0 0 0 1px rgba(15, 23, 42, 0.85), 0 0 10px rgba(56, 189, 248, 0.9)",
        flexShrink: 0
      }
    }), /*#__PURE__*/_jsx("span", {
      style: {
        flex: 1,
        height: 4,
        marginLeft: 2,
        borderRadius: 999,
        background: DROP_LINE_OUTLINE,
        boxShadow: "0 0 0 2px ".concat(DROP_LINE_COLOR, ", 0 0 12px rgba(56, 189, 248, 0.95)")
      }
    })]
  });
}

/** Only this list's own blocks — never nested group/column children. */
var getDirectBlockEls = function getDirectBlockEls(listEl) {
  if (!listEl) return [];
  return _toConsumableArray(listEl.children).filter(function (el) {
    var _el$hasAttribute;
    return (_el$hasAttribute = el.hasAttribute) === null || _el$hasAttribute === void 0 ? void 0 : _el$hasAttribute.call(el, "data-builder-block");
  });
};
var getInsertIndexFromList = function getInsertIndexFromList(listEl, clientY) {
  if (!listEl) return 0;
  var blockEls = getDirectBlockEls(listEl);
  if (blockEls.length === 0) return 0;
  var listRect = listEl.getBoundingClientRect();
  var rects = blockEls.map(function (el) {
    return el.getBoundingClientRect();
  });
  if (clientY <= listRect.top + 8 || clientY <= rects[0].top + 8) return 0;
  if (clientY >= listRect.bottom - 8 || clientY >= rects[rects.length - 1].bottom - 8) return blockEls.length;
  for (var i = 0; i < rects.length; i++) {
    var mid = (rects[i].top + rects[i].bottom) / 2;
    if (clientY < mid) return i;
  }
  return blockEls.length;
};
var getStableInsertIndex = function getStableInsertIndex(listEl, clientY, lastIndexRef) {
  var raw = getInsertIndexFromList(listEl, clientY);
  var prev = lastIndexRef.current;
  var blockEls = getDirectBlockEls(listEl);
  if (raw === 0 || raw === blockEls.length || prev == null || raw === prev) {
    lastIndexRef.current = raw;
    return raw;
  }
  var rects = blockEls.map(function (el) {
    return el.getBoundingClientRect();
  });
  if (rects.length === 0) {
    lastIndexRef.current = raw;
    return raw;
  }
  if (raw > prev) {
    var checkIdx = Math.min(raw - 1, rects.length - 1);
    var mid = (rects[checkIdx].top + rects[checkIdx].bottom) / 2;
    if (clientY < mid + 6) return prev;
  } else {
    var _checkIdx = Math.max(raw, 0);
    var _mid = (rects[_checkIdx].top + rects[_checkIdx].bottom) / 2;
    if (clientY > _mid - 6) return prev;
  }
  lastIndexRef.current = raw;
  return raw;
};
var getDropIndicatorTop = function getDropIndicatorTop(listEl, insertIndex) {
  if (!listEl || insertIndex == null) return null;
  var listRect = listEl.getBoundingClientRect();
  var blockEls = getDirectBlockEls(listEl);
  if (insertIndex <= 0) return 0;
  if (insertIndex >= blockEls.length) {
    return Math.max(0, listRect.height);
  }
  var target = blockEls[insertIndex];
  return target.getBoundingClientRect().top - listRect.top;
};
var isDropTargetActive = function isDropTargetActive(dragOverPos, parentId, columnIndex) {
  var _dragOverPos$parentId, _dragOverPos$columnIn;
  return dragOverPos && dragOverPos.index != null && ((_dragOverPos$parentId = dragOverPos.parentId) !== null && _dragOverPos$parentId !== void 0 ? _dragOverPos$parentId : null) === (parentId !== null && parentId !== void 0 ? parentId : null) && ((_dragOverPos$columnIn = dragOverPos.columnIndex) !== null && _dragOverPos$columnIn !== void 0 ? _dragOverPos$columnIn : null) === (columnIndex !== null && columnIndex !== void 0 ? columnIndex : null);
};
function BlockList(_ref2) {
  var blocks = _ref2.blocks,
    parentId = _ref2.parentId,
    columnIndex = _ref2.columnIndex,
    _ref2$listGap = _ref2.listGap,
    listGap = _ref2$listGap === void 0 ? "12px" : _ref2$listGap,
    _ref2$inheritTextColo = _ref2.inheritTextColor,
    inheritTextColor = _ref2$inheritTextColo === void 0 ? null : _ref2$inheritTextColo,
    _ref2$endDropSpace = _ref2.endDropSpace,
    endDropSpace = _ref2$endDropSpace === void 0 ? null : _ref2$endDropSpace,
    _ref2$listAlignItems = _ref2.listAlignItems,
    listAlignItems = _ref2$listAlignItems === void 0 ? "stretch" : _ref2$listAlignItems,
    _ref2$listJustifyCont = _ref2.listJustifyContent,
    listJustifyContent = _ref2$listJustifyCont === void 0 ? "flex-start" : _ref2$listJustifyCont,
    _ref2$listShrinkWrap = _ref2.listShrinkWrap,
    listShrinkWrap = _ref2$listShrinkWrap === void 0 ? false : _ref2$listShrinkWrap,
    selected = _ref2.selected,
    selectedElement = _ref2.selectedElement,
    selectBlock = _ref2.selectBlock,
    selectElement = _ref2.selectElement,
    dragSourceRef = _ref2.dragSourceRef,
    dragOverPos = _ref2.dragOverPos,
    isDragActive = _ref2.isDragActive,
    handleDragOverCanvas = _ref2.handleDragOverCanvas,
    handleDropCanvas = _ref2.handleDropCanvas,
    handleDragStartCanvas = _ref2.handleDragStartCanvas,
    copy = _ref2.copy,
    paste = _ref2.paste,
    _ref2$canPaste = _ref2.canPaste,
    canPaste = _ref2$canPaste === void 0 ? false : _ref2$canPaste,
    duplicate = _ref2.duplicate,
    moveBlockUp = _ref2.moveBlockUp,
    moveBlockDown = _ref2.moveBlockDown,
    moveBlockOutOfColumn = _ref2.moveBlockOutOfColumn,
    remove = _ref2.remove,
    ungroup = _ref2.ungroup,
    toggleBlockLock = _ref2.toggleBlockLock,
    moveBlockTo = _ref2.moveBlockTo,
    _ref2$viewport = _ref2.viewport,
    viewport = _ref2$viewport === void 0 ? "desktop" : _ref2$viewport,
    signBlockSide = _ref2.signBlockSide,
    getActiveFontFamily = _ref2.getActiveFontFamily,
    editTableHeader = _ref2.editTableHeader,
    editTableCell = _ref2.editTableCell,
    editText = _ref2.editText,
    editCardTitle = _ref2.editCardTitle,
    editListItem = _ref2.editListItem,
    editTwoColumnLeft = _ref2.editTwoColumnLeft,
    editTwoColumnRight = _ref2.editTwoColumnRight,
    editThreeColumn = _ref2.editThreeColumn,
    editContentField = _ref2.editContentField,
    editAccordionItem = _ref2.editAccordionItem,
    editPricingPlan = _ref2.editPricingPlan,
    editPricingFeature = _ref2.editPricingFeature,
    editTestimonial = _ref2.editTestimonial,
    editTimelineItem = _ref2.editTimelineItem,
    _ref2$mentionConfig = _ref2.mentionConfig,
    mentionConfig = _ref2$mentionConfig === void 0 ? null : _ref2$mentionConfig;
  var listRef = useRef(null);
  var lastInsertIndexRef = useRef(null);
  useEffect(function () {
    if (!isDragActive) {
      lastInsertIndexRef.current = null;
    }
  }, [isDragActive]);
  var resolveInsertIndex = function resolveInsertIndex(e) {
    if (!listRef.current) return 0;
    return getStableInsertIndex(listRef.current, e.clientY, lastInsertIndexRef);
  };
  var showIndicator = isDropTargetActive(dragOverPos, parentId, columnIndex);
  var indicatorTop = showIndicator ? getDropIndicatorTop(listRef.current, dragOverPos.index) : null;
  return /*#__PURE__*/_jsxs("div", {
    ref: listRef,
    "data-builder-list": true,
    style: _objectSpread({
      position: "relative",
      // Only fit-content columns hug children. For align-items:center (e.g. 20px
      // heart column) keep width 100% so % children resolve against the column —
      // width:auto made the heart use intrinsic image size and diverge from preview.
      width: listShrinkWrap ? "auto" : "100%",
      maxWidth: "100%",
      minWidth: 0,
      // Grow only to fill an *explicit* parent height (column height control).
      // Do not use height:100% — that resolves against the canvas min-height and
      // adds empty space that preview (content-sized stack) does not have.
      flex: parentId != null ? listShrinkWrap ? "0 0 auto" : "1 1 auto" : undefined,
      alignSelf: parentId != null ? listShrinkWrap ? "flex-start" : "stretch" : undefined,
      height: "auto",
      display: "flex",
      flexDirection: "column",
      alignItems: listShrinkWrap ? "flex-start" : listAlignItems || "stretch",
      justifyContent: listJustifyContent || "flex-start",
      gap: listGap,
      boxSizing: "border-box",
      minHeight: blocks.length === 0 && endDropSpace != null ? Math.max(48, Number(endDropSpace) || 48) : undefined,
      paddingBottom: isDragActive && showIndicator && (dragOverPos === null || dragOverPos === void 0 ? void 0 : dragOverPos.index) === blocks.length ? 20 : undefined
    }, showIndicator && parentId != null ? {
      outline: "2px dashed ".concat(DROP_LINE_COLOR),
      outlineOffset: -2,
      borderRadius: 8
    } : {}),
    onDragOver: function onDragOver(e) {
      e.preventDefault();
      e.stopPropagation();
      handleDragOverCanvas(e, parentId, columnIndex, resolveInsertIndex(e));
    },
    onDrop: function onDrop(e) {
      e.preventDefault();
      e.stopPropagation();
      handleDropCanvas(e, parentId, columnIndex, resolveInsertIndex(e));
    },
    children: [showIndicator && indicatorTop != null && /*#__PURE__*/_jsx(DropIndicator, {
      top: indicatorTop
    }), blocks.map(function (node, index) {
      var _node$responsiveStyle, _node$responsiveEleme, _effectiveStyle, _effectiveStyle2, _effectiveStyle3, _effectiveStyle4, _effectiveStyle5, _effectiveStyle6, _node$style, _effectiveStyle7, _effectiveStyle8, _effectiveStyle9, _effectiveStyle10, _effectiveStyle11, _effectiveStyle$zInde, _effectiveStyle12, _effectiveStyle13, _effectiveStyle$zInde2, _effectiveStyle14, _node$content;
      var effectiveStyle = _objectSpread(_objectSpread({}, node.style || {}), viewport === "desktop" ? {} : ((_node$responsiveStyle = node.responsiveStyles) === null || _node$responsiveStyle === void 0 ? void 0 : _node$responsiveStyle[viewport]) || {});
      effectiveStyle = omitInheritedColumnTextColor(effectiveStyle, node, inheritTextColor);
      var responsiveElements = viewport === "desktop" ? {} : ((_node$responsiveEleme = node.responsiveElementStyles) === null || _node$responsiveEleme === void 0 ? void 0 : _node$responsiveEleme[viewport]) || {};
      var effectiveElementStyles = _objectSpread({}, node.elementStyles || {});
      Object.keys(responsiveElements).forEach(function (key) {
        effectiveElementStyles[key] = _objectSpread(_objectSpread({}, effectiveElementStyles[key] || {}), responsiveElements[key]);
      });
      var renderNode = _objectSpread(_objectSpread({}, node), {}, {
        style: effectiveStyle,
        elementStyles: effectiveElementStyles
      });
      var isNodeSelected = selected === node.id;
      var nodeFont = resolveNodeFontFamily(effectiveStyle, getActiveFontFamily());
      var nodeWeight = resolveFontWeight(nodeFont, (_effectiveStyle = effectiveStyle) === null || _effectiveStyle === void 0 ? void 0 : _effectiveStyle.fontWeight);
      var isAbsolute = ((_effectiveStyle2 = effectiveStyle) === null || _effectiveStyle2 === void 0 ? void 0 : _effectiveStyle2.position) === "absolute";
      var styleForRender = resolveStyleWithBackgroundOverlay(effectiveStyle);
      var _colBgs = styleForRender.columnBackgrounds,
        _colWs = styleForRender.columnWidths,
        _colHs = styleForRender.columnHeights,
        _colPads = styleForRender.columnPaddings,
        _colBs = styleForRender.columnBorderStyles,
        _colBw = styleForRender.columnBorderWidths,
        _colBc = styleForRender.columnBorderColors,
        _colBr = styleForRender.columnBorderRadii,
        _colAi = styleForRender.columnAlignItems,
        _colJc = styleForRender.columnJustifyContents,
        _imgShape = styleForRender.imageShape,
        blockTransform = styleForRender.transform,
        layoutStyleWithGap = _objectWithoutProperties(styleForRender, _excluded);
      // Column gap is applied inside the column renderer (between columns / stacked items).
      // Leaving it on this wrapper makes inspector show a gap that does nothing.
      var layoutStyle = isColumnLayoutType(node.type) ? function () {
        var _gap = layoutStyleWithGap.gap,
          rest = _objectWithoutProperties(layoutStyleWithGap, _excluded2);
        return rest;
      }() : layoutStyleWithGap;
      // Margin lives on the outer selection wrapper so sibling gaps match preview/export
      var outerMarginStyle = pickMarginStyle(effectiveStyle);
      var resolvedLayoutStyle = resolveBorderStyleProps(_objectSpread({
        // Fallback so large font-sizes keep room for descenders when unset
        lineHeight: "1.25"
      }, omitMarginFromStyle(layoutStyle)));
      var isNestedBlock = parentId != null;
      var isImageBlock = node.type === "image";
      var nestedColCount = isNestedColumnContent(node.content) ? (node.content.columns || []).length : 0;
      var singleColumnLayout = isColumnLayoutType(node.type) ? getColumnLayoutGapConfig(node.type, effectiveStyle, nestedColCount || (node.type === "one-column" ? 1 : node.type === "two-column" ? 2 : 3)).isSingleColumn : false;
      var columnOuterWidth = isColumnLayoutType(node.type) ? getColumnLayoutOuterWidth(effectiveStyle, singleColumnLayout) : null;
      var circularColumnSize = isColumnLayoutType(node.type) && singleColumnLayout ? getCircularColumnBoxSize(effectiveStyle) : "";
      // Image width % is applied once inside the image renderer (matches preview/PDF).
      // Keeping it on the selection wrapper too makes circle = width% × width% (too small).
      // Only icon / auto-width buttons / circular badges shrink-wrap. Buttons with an
      // explicit width (e.g. 100%) must stay full-bleed like preview/export.
      // Inside fit-content columns, text/heading also hug content (preview does), otherwise
      // width:100% + cyclic % sizing crushes the column in the builder.
      var shrinkWrapBlock = node.type === "icon" || node.type === "button" && (!((_effectiveStyle3 = effectiveStyle) !== null && _effectiveStyle3 !== void 0 && _effectiveStyle3.width) || effectiveStyle.width === "auto") || listShrinkWrap && !isImageBlock && !isColumnLayoutType(node.type) && node.type !== "button" && (!((_effectiveStyle4 = effectiveStyle) !== null && _effectiveStyle4 !== void 0 && _effectiveStyle4.width) || effectiveStyle.width === "auto" || effectiveStyle.width === "100%");
      var blockShellWidth = isImageBlock ? "100%" : circularColumnSize ? circularColumnSize : columnOuterWidth && columnOuterWidth !== "100%" ? columnOuterWidth : (_effectiveStyle5 = effectiveStyle) !== null && _effectiveStyle5 !== void 0 && _effectiveStyle5.width && effectiveStyle.width !== "auto" && !(listShrinkWrap && effectiveStyle.width === "100%") ? effectiveStyle.width : shrinkWrapBlock ? listShrinkWrap ? "fit-content" : "auto" : "100%";
      var handleSelectFullBlock = function handleSelectFullBlock(event) {
        var _event$currentTarget, _event$currentTarget$, _event$currentTarget2, _event$currentTarget3, _event$target$closest, _event$target;
        var ownWrapper = (_event$currentTarget = event.currentTarget) !== null && _event$currentTarget !== void 0 && (_event$currentTarget$ = _event$currentTarget.hasAttribute) !== null && _event$currentTarget$ !== void 0 && _event$currentTarget$.call(_event$currentTarget, "data-builder-block") ? event.currentTarget : (_event$currentTarget2 = event.currentTarget) === null || _event$currentTarget2 === void 0 || (_event$currentTarget3 = _event$currentTarget2.closest) === null || _event$currentTarget3 === void 0 ? void 0 : _event$currentTarget3.call(_event$currentTarget2, "[data-builder-block]");
        var nearestBlock = (_event$target$closest = (_event$target = event.target).closest) === null || _event$target$closest === void 0 ? void 0 : _event$target$closest.call(_event$target, "[data-builder-block]");

        // Click was on a nested child — never steal selection up to the column/group parent
        if (nearestBlock && ownWrapper && nearestBlock !== ownWrapper) {
          return;
        }

        // Let toolbar actions / unlock button handle themselves
        if (event.target.closest("[data-block-toolbar], button, a, [data-no-position-drag]")) {
          event.stopPropagation();
          return;
        }

        // Text fields keep their own focus + element selection, but must not bubble to canvas
        if (event.target.closest("input, textarea, [contenteditable]")) {
          event.stopPropagation();
          return;
        }
        event.preventDefault();
        event.stopPropagation();
        selectBlock(node.id);
      };
      var blockContentProps = {
        onClick: handleSelectFullBlock,
        style: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, BLOCK_TEXT_WRAP_STYLE), resolvedLayoutStyle), {}, {
          fontFamily: nodeFont,
          fontWeight: nodeWeight,
          position: ((_effectiveStyle6 = effectiveStyle) === null || _effectiveStyle6 === void 0 ? void 0 : _effectiveStyle6.position) || "relative",
          cursor: node.locked ? "not-allowed" : "pointer",
          pointerEvents: node.locked ? "none" : "auto",
          boxSizing: "border-box",
          minWidth: circularColumnSize || (listAlignItems === "stretch" ? 0 : undefined),
          maxWidth: circularColumnSize || resolveStyleMaxWidth(resolvedLayoutStyle, "100%"),
          width: blockShellWidth
        }, circularColumnSize ? {
          height: circularColumnSize,
          minHeight: circularColumnSize,
          maxHeight: circularColumnSize,
          overflow: "hidden",
          flexShrink: 0,
          aspectRatio: "1 / 1"
        } : {}), {}, {
          // visible by default so child selection rings / toolbars aren't cut by group/section overflow
          overflow: circularColumnSize || (_node$style = node.style) !== null && _node$style !== void 0 && _node$style.clipPath ? "hidden" : "visible",
          boxShadow: ((_effectiveStyle7 = effectiveStyle) === null || _effectiveStyle7 === void 0 ? void 0 : _effectiveStyle7.boxShadow) || "none"
        }, styleForRender !== null && styleForRender !== void 0 && styleForRender.backgroundImage ? {
          backgroundSize: styleForRender.backgroundSize || "cover",
          backgroundPosition: styleForRender.backgroundPosition || "center",
          backgroundRepeat: styleForRender.backgroundRepeat || "no-repeat"
        } : {})
      };
      var p = blockContentProps;
      return /*#__PURE__*/_jsxs("div", {
        "data-builder-block": true,
        "data-block-id": node.id,
        "data-nested-block": isNestedBlock ? "true" : undefined,
        onMouseDown: function onMouseDown(event) {
          var _event$target$closest2, _event$target2;
          var nearestBlock = (_event$target$closest2 = (_event$target2 = event.target).closest) === null || _event$target$closest2 === void 0 ? void 0 : _event$target$closest2.call(_event$target2, "[data-builder-block]");
          // Nested child mousedown should not bubble to column parent
          if (nearestBlock && nearestBlock !== event.currentTarget) {
            return;
          }
          // Stop canvas from clearing selection before click handlers run
          if (!event.target.closest("input, textarea, [contenteditable], button, a")) {
            event.stopPropagation();
          }
        },
        onClick: handleSelectFullBlock,
        style: _objectSpread(_objectSpread(_objectSpread({
          position: isAbsolute ? "absolute" : "relative"
        }, isAbsolute ? _objectSpread({
          top: (_effectiveStyle8 = effectiveStyle) === null || _effectiveStyle8 === void 0 ? void 0 : _effectiveStyle8.top,
          right: (_effectiveStyle9 = effectiveStyle) === null || _effectiveStyle9 === void 0 ? void 0 : _effectiveStyle9.right,
          bottom: (_effectiveStyle10 = effectiveStyle) === null || _effectiveStyle10 === void 0 ? void 0 : _effectiveStyle10.bottom,
          left: (_effectiveStyle11 = effectiveStyle) === null || _effectiveStyle11 === void 0 ? void 0 : _effectiveStyle11.left,
          zIndex: (_effectiveStyle$zInde = (_effectiveStyle12 = effectiveStyle) === null || _effectiveStyle12 === void 0 ? void 0 : _effectiveStyle12.zIndex) !== null && _effectiveStyle$zInde !== void 0 ? _effectiveStyle$zInde : 2,
          width: ((_effectiveStyle13 = effectiveStyle) === null || _effectiveStyle13 === void 0 ? void 0 : _effectiveStyle13.width) || "auto",
          maxWidth: resolveStyleMaxWidth(effectiveStyle, "100%")
        }, outerMarginStyle) : _objectSpread(_objectSpread({}, outerMarginStyle), {}, {
          width: blockShellWidth,
          maxWidth: circularColumnSize || resolveStyleMaxWidth(effectiveStyle, "100%")
        }, circularColumnSize ? {
          height: circularColumnSize,
          minHeight: circularColumnSize,
          maxHeight: circularColumnSize,
          flexShrink: 0
        } : {})), {}, {
          fontFamily: nodeFont,
          fontWeight: nodeWeight,
          minWidth: circularColumnSize || (listAlignItems === "stretch" ? 0 : undefined),
          boxSizing: "border-box",
          // Keep selection chrome square/rounded — do NOT clip overflow here or the
          // floating toolbar (top: -40) disappears on circular badge columns.
          borderRadius: isNodeSelected ? 4 : 0,
          overflow: "visible",
          cursor: node.locked ? "not-allowed" : "pointer"
        }, blockTransform && blockTransform !== "none" ? {
          transform: blockTransform,
          transformOrigin: "center center"
        } : {}), {}, {
          // Outline (not border) so selection does not shrink content vs preview
          border: "none",
          outline: isNodeSelected ? "2px solid #38bdf8" : "none",
          outlineOffset: isNodeSelected ? 0 : undefined,
          transition: "outline-color 0.1s ease-in-out, box-shadow 0.15s ease-in-out"
        }, isNodeSelected ? {
          boxShadow: "0 0 0 2px #ffffff, 0 0 0 4px rgba(14, 165, 233, 0.45)",
          zIndex: isAbsolute ? Math.max((_effectiveStyle$zInde2 = (_effectiveStyle14 = effectiveStyle) === null || _effectiveStyle14 === void 0 ? void 0 : _effectiveStyle14.zIndex) !== null && _effectiveStyle$zInde2 !== void 0 ? _effectiveStyle$zInde2 : 2, 50) : isNestedBlock ? 50 : 30
        } : {}),
        children: [node.locked && /*#__PURE__*/_jsxs("button", {
          type: "button",
          "data-no-position-drag": true,
          onClick: function onClick(event) {
            event.preventDefault();
            event.stopPropagation();
            toggleBlockLock(node.id);
          },
          title: "Unlock block",
          style: {
            position: "absolute",
            top: 6,
            right: 6,
            zIndex: 60,
            display: "inline-flex",
            alignItems: "center",
            gap: 5,
            border: "1px solid rgba(255,255,255,0.35)",
            borderRadius: 5,
            background: "#101828",
            color: "#ffffff",
            padding: "5px 8px",
            fontSize: 11,
            fontWeight: 600,
            fontFamily: DEFAULT_FONT,
            cursor: "pointer",
            boxShadow: "0 3px 8px rgba(15,23,42,0.2)"
          },
          children: [/*#__PURE__*/_jsx(BuilderIcon, {
            name: "lock",
            size: 14,
            strokeWidth: 1.75,
            color: "currentColor"
          }), "Unlock"]
        }), isNodeSelected && /*#__PURE__*/_jsxs("div", {
          "data-block-toolbar": true,
          onMouseDown: function onMouseDown(e) {
            return e.stopPropagation();
          },
          onClick: function onClick(e) {
            return e.stopPropagation();
          },
          style: {
            position: "absolute",
            // Sit fully above the block (never overlay heading/text)
            top: -40,
            right: isNestedBlock ? 4 : 0,
            left: "auto",
            zIndex: 100,
            background: "#101828",
            color: "#ffffff",
            fontSize: 11,
            fontWeight: 600,
            fontFamily: DEFAULT_FONT,
            borderRadius: "4px",
            padding: "4px 8px",
            display: "inline-flex",
            alignItems: "center",
            gap: 10,
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.15)",
            userSelect: "none",
            whiteSpace: "nowrap",
            maxWidth: "none",
            pointerEvents: "auto"
          },
          children: [/*#__PURE__*/_jsx("span", {
            draggable: !node.locked,
            onMouseDown: function onMouseDown(e) {
              // Keep native drag from being cancelled by parent selection handlers
              e.stopPropagation();
            },
            onDragStart: function onDragStart(e) {
              e.stopPropagation();
              if (!node.locked) handleDragStartCanvas(e, node.id);
            },
            onDragEnd: function onDragEnd(e) {
              e.stopPropagation();
            },
            style: {
              cursor: node.locked ? "not-allowed" : "grab",
              fontSize: 14,
              userSelect: "none",
              padding: "2px 6px 2px 2px",
              borderRight: "1px solid rgba(255,255,255,0.3)",
              touchAction: "none"
            },
            title: "Drag to reorder",
            children: "\u283F"
          }), /*#__PURE__*/_jsx("span", {
            onClick: function onClick(e) {
              e.stopPropagation();
              selectBlock(node.id);
            },
            title: "Select full block",
            style: {
              textTransform: "uppercase",
              cursor: "pointer"
            },
            children: ((_node$content = node.content) === null || _node$content === void 0 ? void 0 : _node$content.sectionLabel) || node.type
          }), isNestedBlock && parentId != null && /*#__PURE__*/_jsx("span", {
            onClick: function onClick(e) {
              e.stopPropagation();
              selectBlock(parentId);
            },
            title: "Select parent column / group",
            style: {
              cursor: "pointer",
              fontSize: 10,
              opacity: 0.85,
              textTransform: "uppercase"
            },
            children: "\u2191 Parent"
          }), /*#__PURE__*/_jsxs("div", {
            style: {
              display: "flex",
              gap: 8
            },
            children: [node.type === "group" && /*#__PURE__*/_jsx("span", {
              onClick: function onClick(e) {
                e.stopPropagation();
                ungroup();
              },
              title: "Ungroup blocks",
              style: {
                cursor: "pointer",
                fontSize: 11
              },
              children: "UNGROUP"
            }), function () {
              var isNested = parentId != null;
              var canMoveUp = !node.locked && (index > 0 || isNested);
              var canMoveDown = !node.locked && (index < blocks.length - 1 || isNested);
              var upTitle = node.locked ? "Unlock to move" : index > 0 ? "Move up" : isNested ? "Move out of column (above)" : "Already at top";
              var downTitle = node.locked ? "Unlock to move" : index < blocks.length - 1 ? "Move down" : isNested ? "Move out of column (below)" : "Already at bottom";
              return /*#__PURE__*/_jsxs(_Fragment, {
                children: [/*#__PURE__*/_jsx("span", {
                  onClick: function onClick(e) {
                    e.stopPropagation();
                    if (canMoveUp && typeof moveBlockUp === "function") {
                      moveBlockUp();
                    }
                  },
                  title: upTitle,
                  style: {
                    cursor: canMoveUp ? "pointer" : "not-allowed",
                    display: "inline-flex",
                    alignItems: "center",
                    opacity: canMoveUp ? 1 : 0.35
                  },
                  children: /*#__PURE__*/_jsx(BuilderIcon, {
                    name: "arrow-up",
                    size: 16,
                    strokeWidth: 1.75,
                    color: "currentColor"
                  })
                }), /*#__PURE__*/_jsx("span", {
                  onClick: function onClick(e) {
                    e.stopPropagation();
                    if (canMoveDown && typeof moveBlockDown === "function") {
                      moveBlockDown();
                    }
                  },
                  title: downTitle,
                  style: {
                    cursor: canMoveDown ? "pointer" : "not-allowed",
                    display: "inline-flex",
                    alignItems: "center",
                    opacity: canMoveDown ? 1 : 0.35
                  },
                  children: /*#__PURE__*/_jsx(BuilderIcon, {
                    name: "arrow-down",
                    size: 16,
                    strokeWidth: 1.75,
                    color: "currentColor"
                  })
                }), isNested && /*#__PURE__*/_jsx("span", {
                  onClick: function onClick(e) {
                    e.stopPropagation();
                    if (!node.locked && typeof moveBlockOutOfColumn === "function") {
                      moveBlockOutOfColumn();
                    }
                  },
                  title: node.locked ? "Unlock to move" : "Move out of column",
                  style: {
                    cursor: node.locked ? "not-allowed" : "pointer",
                    display: "inline-flex",
                    alignItems: "center",
                    opacity: node.locked ? 0.35 : 1
                  },
                  children: /*#__PURE__*/_jsx(BuilderIcon, {
                    name: "exit",
                    size: 16,
                    strokeWidth: 1.75,
                    color: "currentColor"
                  })
                })]
              });
            }(), /*#__PURE__*/_jsx("span", {
              onClick: function onClick(e) {
                e.stopPropagation();
                toggleBlockLock(node.id);
              },
              title: node.locked ? "Unlock Block" : "Lock Block",
              style: {
                cursor: "pointer",
                display: "inline-flex",
                alignItems: "center"
              },
              children: /*#__PURE__*/_jsx(BuilderIcon, {
                name: node.locked ? "lock" : "unlock",
                size: 16,
                strokeWidth: 1.75,
                color: "currentColor"
              })
            }), /*#__PURE__*/_jsx("span", {
              onClick: function onClick(e) {
                e.stopPropagation();
                copy();
              },
              title: "Copy Block (Ctrl+C)",
              style: {
                cursor: "pointer",
                fontSize: 11
              },
              children: /*#__PURE__*/_jsx(BuilderIcon, {
                name: "copy",
                size: 16,
                strokeWidth: 1.75,
                color: "currentColor"
              })
            }), /*#__PURE__*/_jsx("span", {
              onClick: function onClick(e) {
                e.stopPropagation();
                if (canPaste && typeof paste === "function") {
                  paste();
                }
              },
              title: canPaste ? "Paste Block (Ctrl+V)" : "Copy a block first to paste",
              style: {
                cursor: canPaste ? "pointer" : "not-allowed",
                fontSize: 11,
                opacity: canPaste ? 1 : 0.35
              },
              children: /*#__PURE__*/_jsx(BuilderIcon, {
                name: "paste",
                size: 16,
                strokeWidth: 1.75,
                color: "currentColor"
              })
            }), /*#__PURE__*/_jsx("span", {
              onClick: function onClick(e) {
                e.stopPropagation();
                duplicate();
              },
              title: "Duplicate Block (Ctrl+D)",
              style: {
                cursor: "pointer",
                fontSize: 11
              },
              children: /*#__PURE__*/_jsx(BuilderIcon, {
                name: "duplicate",
                size: 16,
                strokeWidth: 1.75,
                color: "currentColor"
              })
            }), /*#__PURE__*/_jsx("span", {
              onClick: function onClick(e) {
                e.stopPropagation();
                remove();
              },
              title: "Delete Block",
              style: {
                cursor: "pointer",
                fontSize: 11,
                color: "#fca5a5"
              },
              children: /*#__PURE__*/_jsx(BuilderIcon, {
                name: "delete",
                size: 16,
                strokeWidth: 1.75,
                color: "currentColor"
              })
            })]
          })]
        }), /*#__PURE__*/_jsx(CanvasBlockRenderer, {
          BlockList: BlockList,
          node: renderNode,
          nodeFont: nodeFont,
          nodeWeight: nodeWeight,
          isNodeSelected: isNodeSelected,
          p: p,
          signBlockSide: signBlockSide,
          editTableHeader: editTableHeader,
          editTableCell: editTableCell,
          editText: editText,
          editCardTitle: editCardTitle,
          editListItem: editListItem,
          editTwoColumnLeft: editTwoColumnLeft,
          editTwoColumnRight: editTwoColumnRight,
          editThreeColumn: editThreeColumn,
          editContentField: editContentField,
          editAccordionItem: editAccordionItem,
          editPricingPlan: editPricingPlan,
          editPricingFeature: editPricingFeature,
          editTestimonial: editTestimonial,
          editTimelineItem: editTimelineItem,
          onSelectBlock: selectBlock,
          onSelectElement: selectElement,
          selectedElement: selectedElement,
          handleDragOverCanvas: handleDragOverCanvas,
          handleDropCanvas: handleDropCanvas,
          handleDragStartCanvas: handleDragStartCanvas,
          copy: copy,
          paste: paste,
          canPaste: canPaste,
          duplicate: duplicate,
          moveBlockUp: moveBlockUp,
          moveBlockDown: moveBlockDown,
          moveBlockOutOfColumn: moveBlockOutOfColumn,
          remove: remove,
          ungroup: ungroup,
          toggleBlockLock: toggleBlockLock,
          moveBlockTo: moveBlockTo,
          viewport: viewport,
          selected: selected,
          dragSourceRef: dragSourceRef,
          dragOverPos: dragOverPos,
          isDragActive: isDragActive,
          getActiveFontFamily: getActiveFontFamily,
          mentionConfig: mentionConfig,
          inheritTextColor: inheritTextColor
        })]
      }, node.id);
    })]
  });
}
export default function Canvas(_ref3) {
  var _pageDimensions$width, _pageDimensions$minHe;
  var viewport = _ref3.viewport,
    page = _ref3.page,
    selected = _ref3.selected,
    selectedElement = _ref3.selectedElement,
    selectBlock = _ref3.selectBlock,
    selectElement = _ref3.selectElement,
    dragSourceRef = _ref3.dragSourceRef,
    dragOverPos = _ref3.dragOverPos,
    setDragOverPos = _ref3.setDragOverPos,
    isDragActive = _ref3.isDragActive,
    handleDropCanvasBg = _ref3.handleDropCanvasBg,
    handleDragOverCanvas = _ref3.handleDragOverCanvas,
    handleDropCanvas = _ref3.handleDropCanvas,
    handleDragStartCanvas = _ref3.handleDragStartCanvas,
    copy = _ref3.copy,
    paste = _ref3.paste,
    _ref3$canPaste = _ref3.canPaste,
    canPaste = _ref3$canPaste === void 0 ? false : _ref3$canPaste,
    duplicate = _ref3.duplicate,
    moveBlockUp = _ref3.moveBlockUp,
    moveBlockDown = _ref3.moveBlockDown,
    moveBlockOutOfColumn = _ref3.moveBlockOutOfColumn,
    remove = _ref3.remove,
    ungroup = _ref3.ungroup,
    toggleBlockLock = _ref3.toggleBlockLock,
    moveBlockTo = _ref3.moveBlockTo,
    signBlockSide = _ref3.signBlockSide,
    getActiveFontFamily = _ref3.getActiveFontFamily,
    _ref3$globalBackgroun = _ref3.globalBackgroundColor,
    globalBackgroundColor = _ref3$globalBackgroun === void 0 ? "#FFFFFF" : _ref3$globalBackgroun,
    _ref3$globalBackgroun2 = _ref3.globalBackgroundImage,
    globalBackgroundImage = _ref3$globalBackgroun2 === void 0 ? "" : _ref3$globalBackgroun2,
    getActiveTextColor = _ref3.getActiveTextColor,
    _ref3$documentPadding = _ref3.documentPadding,
    documentPadding = _ref3$documentPadding === void 0 ? 30 : _ref3$documentPadding,
    _ref3$documentPageSiz = _ref3.documentPageSize,
    documentPageSize = _ref3$documentPageSiz === void 0 ? "auto" : _ref3$documentPageSiz,
    _ref3$showSafeArea = _ref3.showSafeArea,
    showSafeArea = _ref3$showSafeArea === void 0 ? false : _ref3$showSafeArea,
    _ref3$showGrid = _ref3.showGrid,
    showGrid = _ref3$showGrid === void 0 ? false : _ref3$showGrid,
    editTableHeader = _ref3.editTableHeader,
    editTableCell = _ref3.editTableCell,
    editText = _ref3.editText,
    editCardTitle = _ref3.editCardTitle,
    editListItem = _ref3.editListItem,
    editTwoColumnLeft = _ref3.editTwoColumnLeft,
    editTwoColumnRight = _ref3.editTwoColumnRight,
    editThreeColumn = _ref3.editThreeColumn,
    editContentField = _ref3.editContentField,
    editAccordionItem = _ref3.editAccordionItem,
    editPricingPlan = _ref3.editPricingPlan,
    editPricingFeature = _ref3.editPricingFeature,
    editTestimonial = _ref3.editTestimonial,
    editTimelineItem = _ref3.editTimelineItem,
    _ref3$mentionConfig = _ref3.mentionConfig,
    mentionConfig = _ref3$mentionConfig === void 0 ? null : _ref3$mentionConfig;
  var workspaceRef = useRef(null);
  var scrollContainerRef = useRef(null);
  var _useState = useState({
      width: 0,
      height: 0
    }),
    _useState2 = _slicedToArray(_useState, 2),
    workspaceSize = _useState2[0],
    setWorkspaceSize = _useState2[1];
  useEffect(function () {
    var el = workspaceRef.current;
    if (!el || typeof ResizeObserver === "undefined") return undefined;
    var updateSize = function updateSize() {
      setWorkspaceSize({
        width: el.clientWidth,
        height: el.clientHeight
      });
    };
    updateSize();
    var observer = new ResizeObserver(updateSize);
    observer.observe(el);
    return function () {
      return observer.disconnect();
    };
  }, []);
  var autoScrollRafRef = useRef(null);
  useEffect(function () {
    if (!isDragActive) {
      if (autoScrollRafRef.current) {
        cancelAnimationFrame(autoScrollRafRef.current);
        autoScrollRafRef.current = null;
      }
      return undefined;
    }
    var scrollContainer = scrollContainerRef.current;
    if (!scrollContainer) return undefined;
    var currentSpeed = 0;
    var scrollStep = function scrollStep() {
      if (currentSpeed !== 0 && scrollContainer) {
        scrollContainer.scrollTop += currentSpeed;
      }
      autoScrollRafRef.current = requestAnimationFrame(scrollStep);
    };
    var handleDragOverAutoScroll = function handleDragOverAutoScroll(e) {
      var rect = scrollContainer.getBoundingClientRect();
      var topThreshold = rect.top + 90;
      var bottomThreshold = rect.bottom - 90;
      if (e.clientY < topThreshold && e.clientY >= rect.top - 40) {
        var ratio = Math.max(0, Math.min(1, (topThreshold - e.clientY) / 90));
        currentSpeed = -Math.round(4 + ratio * 20);
        if (!autoScrollRafRef.current) {
          autoScrollRafRef.current = requestAnimationFrame(scrollStep);
        }
      } else if (e.clientY > bottomThreshold && e.clientY <= rect.bottom + 40) {
        var _ratio = Math.max(0, Math.min(1, (e.clientY - bottomThreshold) / 90));
        currentSpeed = Math.round(4 + _ratio * 20);
        if (!autoScrollRafRef.current) {
          autoScrollRafRef.current = requestAnimationFrame(scrollStep);
        }
      } else {
        currentSpeed = 0;
        if (autoScrollRafRef.current) {
          cancelAnimationFrame(autoScrollRafRef.current);
          autoScrollRafRef.current = null;
        }
      }
    };
    var stopAutoScroll = function stopAutoScroll() {
      currentSpeed = 0;
      if (autoScrollRafRef.current) {
        cancelAnimationFrame(autoScrollRafRef.current);
        autoScrollRafRef.current = null;
      }
    };
    window.addEventListener("dragover", handleDragOverAutoScroll, {
      passive: true
    });
    window.addEventListener("dragend", stopAutoScroll, {
      passive: true
    });
    window.addEventListener("drop", stopAutoScroll, {
      passive: true
    });
    return function () {
      stopAutoScroll();
      window.removeEventListener("dragover", handleDragOverAutoScroll);
      window.removeEventListener("dragend", stopAutoScroll);
      window.removeEventListener("drop", stopAutoScroll);
    };
  }, [isDragActive]);

  // Do not auto-scroll on select — it pushes the canvas and makes the last block
  // appear to jump downward whenever any block/section is clicked.
  // (Layers panel / keyboard nav can scroll later if needed.)

  // Desktop canvas width must match preview/export (max-width: 880px). Shrinking the
  // canvas to fit sidebars made columns narrower and broke headings mid-word.
  // On narrow workspaces we keep the logical width and scale visually instead.
  var DESKTOP_WIDTH = 880;
  // Tight workspaces trade padding for canvas width so the page scales up more.
  var isTightWorkspace = workspaceSize.width > 0 && workspaceSize.width < 820;
  var canvasPadTop = isTightWorkspace ? 40 : 56;
  var canvasPadBottom = isTightWorkspace ? 32 : 48;
  var canvasPadX = isTightWorkspace ? 12 : 24;
  var desktopWidth = DESKTOP_WIDTH;
  var desktopMinHeight = workspaceSize.height > 0 ? Math.max(workspaceSize.height - (canvasPadTop + canvasPadBottom), 0) : undefined;
  var pageDimensions = {
    a4: {
      width: 794,
      minHeight: 1123
    },
    letter: {
      width: 816,
      minHeight: 1056
    },
    legal: {
      width: 816,
      minHeight: 1344
    }
  }[documentPageSize];
  var paperWidth = viewport === "mobile" ? 375 : viewport === "tablet" ? 768 : (_pageDimensions$width = pageDimensions === null || pageDimensions === void 0 ? void 0 : pageDimensions.width) !== null && _pageDimensions$width !== void 0 ? _pageDimensions$width : desktopWidth;
  var availableWidth = Math.max(0, workspaceSize.width - canvasPadX * 2);
  var fitScale = workspaceSize.width > 0 && paperWidth > 0 ? Math.min(1, availableWidth / paperWidth) : 1;
  var paperRef = useRef(null);
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    paperHeight = _useState4[0],
    setPaperHeight = _useState4[1];
  useLayoutEffect(function () {
    var el = paperRef.current;
    if (!el || typeof ResizeObserver === "undefined") return undefined;
    var update = function update() {
      return setPaperHeight(el.offsetHeight || 0);
    };
    update();
    var observer = new ResizeObserver(update);
    observer.observe(el);
    return function () {
      return observer.disconnect();
    };
  }, [page === null || page === void 0 ? void 0 : page.tree, viewport, documentPadding, documentPageSize, globalBackgroundColor, globalBackgroundImage]);
  return /*#__PURE__*/_jsx("div", {
    ref: workspaceRef,
    style: {
      flex: 1,
      minWidth: 0,
      minHeight: 0,
      position: "relative",
      background: UI.canvas,
      overflow: "hidden"
    },
    children: /*#__PURE__*/_jsx("div", {
      ref: scrollContainerRef,
      onMouseDown: function onMouseDown(e) {
        // Only clear selection when pressing on empty canvas, not on a block
        if (e.target.closest("[data-builder-block], [data-block-toolbar]")) return;
        selectBlock(null);
      },
      onClick: function onClick(e) {
        if (e.target.closest("[data-builder-block], [data-block-toolbar]")) return;
        selectBlock(null);
      },
      style: {
        position: "absolute",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        overflowY: "auto",
        overflowX: fitScale < 1 ? "hidden" : "auto",
        padding: "".concat(canvasPadTop, "px ").concat(canvasPadX, "px ").concat(canvasPadBottom, "px"),
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
      },
      children: /*#__PURE__*/_jsx("div", {
        style: {
          width: paperWidth * fitScale,
          height: paperHeight > 0 ? paperHeight * fitScale : undefined,
          flexShrink: 0,
          position: "relative"
        },
        children: /*#__PURE__*/_jsxs("div", {
          ref: paperRef,
          onDragOver: function onDragOver(e) {
            e.preventDefault();
            if (dragSourceRef.current === "sidebar") {
              e.dataTransfer.dropEffect = "copy";
            }
          },
          onDragLeave: function onDragLeave(e) {
            if (!e.currentTarget.contains(e.relatedTarget)) {
              setDragOverPos(EMPTY_DROP_POS);
            }
          },
          onDrop: handleDropCanvasBg,
          style: {
            width: paperWidth,
            // Keep fixed preview width — scale wrapper fits narrow workspaces
            // without changing layout (matches export/preview).
            maxWidth: paperWidth,
            flexShrink: 0,
            minHeight: viewport === "desktop" ? (_pageDimensions$minHe = pageDimensions === null || pageDimensions === void 0 ? void 0 : pageDimensions.minHeight) !== null && _pageDimensions$minHe !== void 0 ? _pageDimensions$minHe : desktopMinHeight : 600,
            display: "flex",
            flexDirection: "column",
            backgroundColor: globalBackgroundColor || "#ffffff",
            backgroundImage: function () {
              var layers = [];
              if (showGrid) {
                layers.push("linear-gradient(rgba(148,163,184,.22) 1px, transparent 1px)", "linear-gradient(90deg, rgba(148,163,184,.22) 1px, transparent 1px)");
              }
              if (globalBackgroundImage) {
                layers.push("url(\"".concat(globalBackgroundImage, "\")"));
              }
              return layers.length ? layers.join(", ") : "none";
            }(),
            backgroundSize: showGrid ? globalBackgroundImage ? "10px 10px, 10px 10px, cover" : "10px 10px" : globalBackgroundImage ? "cover" : "auto",
            backgroundPosition: globalBackgroundImage ? "center" : undefined,
            backgroundRepeat: showGrid ? globalBackgroundImage ? "repeat, repeat, no-repeat" : "repeat" : globalBackgroundImage ? "no-repeat" : undefined,
            color: (typeof getActiveTextColor === "function" ? getActiveTextColor() : null) || "#334155",
            fontFamily: getActiveFontFamily(),
            borderRadius: documentPadding === 0 ? 0 : 12,
            boxShadow: UI.shadowMd,
            padding: documentPadding,
            boxSizing: "border-box",
            overflowX: "visible",
            overflowY: "visible",
            position: "relative",
            border: viewport !== "desktop" ? "3px solid #101828" : "none",
            transform: fitScale < 1 ? "scale(".concat(fitScale, ")") : undefined,
            transformOrigin: "top left",
            transition: "width 0.3s cubic-bezier(0.4, 0, 0.2, 1), padding 0.3s"
          },
          children: [showSafeArea && /*#__PURE__*/_jsx("div", {
            "aria-hidden": "true",
            style: {
              position: "absolute",
              inset: 24,
              border: "1px dashed rgba(239, 68, 68, 0.65)",
              zIndex: 9998,
              pointerEvents: "none",
              borderRadius: 2
            },
            children: /*#__PURE__*/_jsx("span", {
              style: {
                position: "absolute",
                top: 2,
                left: 4,
                color: "#dc2626",
                background: "rgba(255,255,255,.85)",
                fontSize: 9,
                padding: "1px 3px"
              },
              children: "PRINT SAFE AREA"
            })
          }), viewport !== "desktop" && /*#__PURE__*/_jsxs("div", {
            style: {
              textAlign: "center",
              fontSize: 10,
              color: "#101828",
              fontWeight: 700,
              textTransform: "uppercase",
              letterSpacing: "0.1em",
              marginBottom: 12,
              userSelect: "none",
              flexShrink: 0
            },
            children: ["-- ", viewport.toUpperCase(), " VIEWPORT --"]
          }), page.tree.length === 0 ? /*#__PURE__*/_jsxs("div", {
            style: {
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              flex: 1,
              minHeight: 350,
              color: "#6b7280",
              border: "2px dashed #cbd5e1",
              borderRadius: 8
            },
            children: [/*#__PURE__*/_jsx(BuilderIcon, {
              name: "templates",
              size: 28,
              color: UI.textFaint
            }), /*#__PURE__*/_jsx("span", {
              style: {
                fontWeight: 500
              },
              children: "Canvas is Empty"
            }), /*#__PURE__*/_jsx("span", {
              style: {
                fontSize: 13,
                marginTop: 4
              },
              children: "Drag blocks from the left panel or pick a template to start."
            })]
          }) : /*#__PURE__*/_jsx(BlockList, {
            blocks: page.tree,
            parentId: null,
            columnIndex: null,
            listGap: "0",
            selected: selected,
            selectedElement: selectedElement,
            selectBlock: selectBlock,
            selectElement: selectElement,
            dragSourceRef: dragSourceRef,
            dragOverPos: dragOverPos,
            isDragActive: isDragActive,
            handleDragOverCanvas: handleDragOverCanvas,
            handleDropCanvas: handleDropCanvas,
            handleDragStartCanvas: handleDragStartCanvas,
            copy: copy,
            paste: paste,
            canPaste: canPaste,
            duplicate: duplicate,
            moveBlockUp: moveBlockUp,
            moveBlockDown: moveBlockDown,
            moveBlockOutOfColumn: moveBlockOutOfColumn,
            remove: remove,
            ungroup: ungroup,
            toggleBlockLock: toggleBlockLock,
            moveBlockTo: moveBlockTo,
            viewport: viewport,
            signBlockSide: signBlockSide,
            getActiveFontFamily: getActiveFontFamily,
            editTableHeader: editTableHeader,
            editTableCell: editTableCell,
            editText: editText,
            editCardTitle: editCardTitle,
            editListItem: editListItem,
            editTwoColumnLeft: editTwoColumnLeft,
            editTwoColumnRight: editTwoColumnRight,
            editThreeColumn: editThreeColumn,
            editContentField: editContentField,
            editAccordionItem: editAccordionItem,
            editPricingPlan: editPricingPlan,
            editPricingFeature: editPricingFeature,
            editTestimonial: editTestimonial,
            editTimelineItem: editTimelineItem,
            mentionConfig: mentionConfig
          })]
        })
      })
    })
  });
}
var EMPTY_DROP_POS = {
  parentId: null,
  columnIndex: null,
  index: null,
  blockId: null
};